import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconEdgeBottom16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconEdgeBottom16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M12.558 10.945a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0m-1.5 3.113a.5.5 0 1 0 0-1h-6a.5.5 0 1 0 0 1zM7.308 2.695a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0m3.5.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5m-8.003 8.25a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5m9.753-3.75a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0m-9.753.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5m9.753-3.75a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0m-9.753.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5m1.753-3a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconEdgeBottom16);
